import { api } from "@repo/convex/api";
import { useObservedMutation } from "@/hooks/use-observed-convex";

// ============================================================================
// Notifications Feature - Mutation Hooks
// ============================================================================
// Hooks for notification state changes (read, delete).

/**
 * Mark a single notification as read.
 * Sets readAt timestamp on the notification.
 */
export function useMarkNotificationAsRead() {
  return useObservedMutation(api.notifications.markAsRead, {
    feature: "notifications",
    operation: "mark-as-read",
    includeRequestId: true,
  });
}

/**
 * Mark all unread notifications as read for the current user.
 * Used by the "Mark all as read" action in the popover header.
 */
export function useMarkAllNotificationsAsRead() {
  return useObservedMutation(api.notifications.markAllAsRead, {
    feature: "notifications",
    operation: "mark-all-as-read",
    includeRequestId: true,
  });
}

/**
 * Soft-delete a notification.
 * Removes it from the user's notification list.
 */
export function useRemoveNotification() {
  return useObservedMutation(api.notifications.remove, {
    feature: "notifications",
    operation: "remove",
    includeRequestId: true,
  });
}
